import { pageContainerStyle } from "@commonStyle";
import { useResponsive } from "@hooks";
import { Platform, StyleSheet, useWindowDimensions } from "react-native";

export default function useGestionCETStyle() {
    const isResponsive = useResponsive();
    const { width } = useWindowDimensions();
    const isTablet = width >= 768;
    const tabletScale = 1.2
    return {
        styles: StyleSheet.create({
            container: {
                ...pageContainerStyle,
                backgroundColor: '#ffffff',
                paddingHorizontal: 16,
                paddingTop: 20,
                height: '100%',
                gap: 20
            },
            subContent: {
                flex: 1,
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                gap: 10
            },
            column: {
                width: isResponsive ? '100%' : '45%',
                gap: 10,
            },
            rightText: {
                textAlign: 'right'
            },
            modernCard: {
                backgroundColor: 'white',
                padding: 20,
                gap: 5,
                borderRadius: 16,
                elevation: 4,
                shadowOpacity: 0.1,
                shadowRadius: 8,
                shadowOffset: { width: 0, height: 4 },
                borderWidth: 1,
                borderColor: '#e0e0e0',
                ...Platform.select({
                    ios: {
                        shadowColor: '#000',
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.1,
                        shadowRadius: 4,
                    },
                    web: {
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    },
                }),
            },
            dotationsContainer: {
                gap: 10,
            },
            dotation: {
                borderWidth: 1,
                borderLeftWidth: 5,
                flexDirection: 'row',
                justifyContent: 'space-between',
                flex: 1,
                borderRadius: 5,
                padding: 10,
                borderColor: '#666666'
            },
            form: {
                gap: 20,
                alignItems: 'center'
            },
            formElement: {
                flexDirection: "column",
                justifyContent: 'space-between',
                width: isResponsive ? '90%' : '60%',
                gap: 5
            },
            formInput:{
                flex: 1,
                borderWidth: 1,
                borderRadius: 10,
                padding: 5,
                borderColor: "#666666",
            },
            buttonAccept:{
                backgroundColor: '#3b82f6',
                padding: 10,
                borderRadius: 20,
                alignItems: 'center',
                justifyContent: 'center',
            },
            buttonAcceptDisabled: {
                backgroundColor: '#3b82f655',
            },
            buttonText: {
                color: 'white',
                fontSize: 16,
                fontWeight: 'bold',
            },
            title: {
                fontSize: 24,
                fontWeight: '600',
                color: '#374151',
            },
            mainText: {
                fontSize: 16,
            },
            mainInfo: {
                alignItems: 'center',
                marginBottom: 20,
                paddingVertical: 16,
                backgroundColor: '#f8f9fa',
                borderRadius: 12,
            },
            primaryStat: {
                alignItems: 'center',
            },
            primaryLabel: {
                fontSize: 14 * (isTablet ? tabletScale : 1),
                color: '#666',
            },
            primaryValue: {
                fontSize: 32 * (isTablet ? tabletScale : 1),
                fontWeight: 'bold',
            },
            quickStats: {
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingVertical: 12,
                borderTopWidth: 1,
                borderTopColor: '#e9ecef',
            },
            statItem: {
                alignItems: 'center',
            },
            statLabel: {
                fontSize: 12 * (isTablet ? tabletScale : 1),
                color: '#666',
                marginBottom: 4,
            },
            statValue: {
                fontSize: 16 * (isTablet ? tabletScale : 1),
                fontWeight: '600',
                color: '#333',
            },
            dotationColumn: {
                flexDirection: "column",
                justifyContent: 'space-between',
                width: "50%",
                gap: 5
            },
            dureeContainer: {
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: isResponsive ? 'wrap' : 'nowrap',
                gap: 10,
                padding: 10,
            },
            dureeElement: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-around',
                gap: 10,
            },
            indications: {
                fontStyle: 'italic',
                color: "#666666",
                fontSize: 12
            },
            texteJours: {
                flexDirection: "column"
            }
        })
    }
}
